import { render, staticRenderFns } from "./OnBoardingApp.vue?vue&type=template&id=07a0c4fc&scoped=true&"
import script from "./OnBoardingApp.vue?vue&type=script&lang=js&"
export * from "./OnBoardingApp.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingApp.vue?vue&type=style&index=0&id=07a0c4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a0c4fc",
  null
  
)

export default component.exports